import React from 'react';
import { useTranslation } from 'react-i18next';

import { TSearchableSelectTagsListProps } from '@/shared/components/ui/form/components/searchable-select/components/tags-list/searchable-select-tags-list.types';
import { Tags } from '@/shared/components/ui/tags/tags';
import { TTag } from '@/shared/components/ui/tags/tags.types';

export const SearchableSelectTagsList = <TOptionShape,>({
  options,
  enableTooltip = false,
}: TSearchableSelectTagsListProps<TOptionShape>) => {
  const { t } = useTranslation();

  // Only a plain string reads in a tooltip; a node (chips, icons) is left out.
  const tags: TTag[] = options.map((option) => ({
    name: typeof option === 'string' ? option : option?.label,
    description:
      typeof option?.additionalInfo === 'string'
        ? option.additionalInfo
        : undefined,
  }));

  return (
    <Tags
      disableTooltip={!enableTooltip}
      visibleTags={0}
      tags={tags}
      customLabel={(count) =>
        t('ui:selected_items', {
          count,
        })
      }
    />
  );
};
